// extracted by mini-css-extract-plugin
export default {"homeContact":"HomeContact_homeContact__L7-Zl","homeContactTitle":"HomeContact_homeContactTitle__mrrWD","homeContactText":"HomeContact_homeContactText__+miRT"};